import React, { useState } from "react"
import { Link } from "gatsby"
import tw, { styled } from "twin.macro"
import { useBreakpoint } from "gatsby-plugin-breakpoints"

const GatsbyLink = styled(Link)`
  ${tw`block py-0.5`}
`
const ExternalLink = styled.a`
  ${tw`block py-0.5`}
`
const Title = styled.div`
  ${tw`text-white text-lg uppercase py-4 flex justify-between items-center `}
`
const IconButton = styled.button`
  ${tw`transition-transform w-6 h-6`}
  transform: ${props => (props.open ? "rotate(0turn)" : "rotate(0.5turn)")};
`
const Svg = styled.img`
  ${tw`w-full h-full`}
`
const List = styled.div`
  ${tw`text-white`}
`

const FooterSection = ({ title, links = [] }) => {
  const breakpoints = useBreakpoint()
  const isMobile = Object.values(breakpoints).every(value => value === false)
  const [open, setOpen] = useState(false)
  return (
    <div>
      <Title>
        <div>{title}</div>
        {isMobile && (
          <IconButton open={open} onClick={() => setOpen(!open)}>
            <Svg src="/img/svg/chevron_up.svg" alt="collapse" />
          </IconButton>
        )}
      </Title>
      {((isMobile && open) || !isMobile) && (
        <List>
          {links.map((link, idx) => {
            if (link.external) {
              return (
                <ExternalLink key={idx} href={link.url} target="_blank">
                  {link.label}
                </ExternalLink>
              )
            } else {
              return (
                <GatsbyLink key={idx} to={link.url}>
                  {link.label}
                </GatsbyLink>
              )
            }
          })}
        </List>
      )}
    </div>
  )
}

export default FooterSection
